import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { get as _get } from 'lodash';
import { CrmCommunity } from '@app-models/index';
import { APIs } from '@app-settings/index';
import { HttpHeaderService } from '@app-services/http-header.service';
@Injectable()
export class TrainingCommunityService {
	constructor(
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
	) {
	}
	getCrmCommunities(uuid: string = null, skip: number = 0, take: number = 0) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_communities;
		if (uuid)
			api += '/' + uuid;
		let params: HttpParams = new HttpParams;
		if (skip)
			params = params.set('skip', `${skip}`);
		if (take)
			params = params.set('take', `${take}`);
		return this._httpClient.get(api, { headers: headers });
	}
	getCrmCommunities_category() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_communities + '/category_exist';
		return this._httpClient.get(api, { headers: headers });
	}
	getCommunityDetails(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_communities;
		if (uuid)
			api += '/' + uuid;
		return this._httpClient.get(api, { headers: headers });
	}
	getCommunityMembers(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_communities;
		if (uuid)
			api += '/' + uuid + '/members';
		return this._httpClient.get(api, { headers: headers });
	}
	getCommunityStats(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_communities;
		if (uuid)
			api += '/' + uuid + '/statistics';
		return this._httpClient.get(api, { headers: headers });
	}
	getCrmCommunitiesWithStatistics(uuid: string = null, skip: number = 0, take: number = 0) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_communities;
		if (uuid)
			api += '/' + uuid;
		let params: HttpParams = new HttpParams;
		if (skip)
			params = params.set('skip', `${skip}`);
		if (take)
			params = params.set('take', `${take}`);
		return this._httpClient.get(api, { headers: headers, params: params });
	}
	insertCrmCommunity(body: CrmCommunity) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_communities, body, { headers: headers });
	}
	updateCrmCommunities(body: CrmCommunity, uuid: string, old_cat_id) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(APIs.crm_communities + `/${uuid}?old_cat_id=${old_cat_id}`, body, { headers: headers });
	}
	deleteCrmCommunities(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		const api = `${APIs.crm_communities}/${uuid}`;
		return this._httpClient.delete(api, { headers: headers });
	}
	deleteCrmCommunitiesmember(uuid: string, cuuid = null,current_user:string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		const api = `${APIs.crm_communities}/${uuid}/${cuuid}?current_user=${current_user}`;
		return this._httpClient.delete(api, { headers: headers });
	}
	updateCrmCommunitiesmember(uuid: string, body = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		const api = `${APIs.crm_communities}/${uuid}/members`;
		return this._httpClient.put(api, body, { headers: headers });
	}
	updateExistingCommunitiesmember(body = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers )
			return of(null);
		const api = `${APIs.crm_communities}/update-existing-members`;
		return this._httpClient.post(api, body, { headers: headers });
	}
	getUsers() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.users;
		return this._httpClient.get(api, { headers: headers });
	}
	getcommunitiesstatics() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		const api = `${APIs.crm_communities}/statistics`;
		return this._httpClient.get(api, { headers: headers });
	}
	getcrmUsers(uuid = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers) {
			return of(null);
		} else {
			let api = APIs.crm_users;
			if (uuid)
				api += '/' + uuid;
			return this._httpClient.get(api, { headers: headers });
		}
	}
}
